import React from 'react';
import ReactDOM from 'react-dom';
import Translate from '../core/Translate';
const KEY_ESC = 27;
const KEY_ENTER = 13;

class InstantEditValidateBox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isEditMode: false,
			value: props.model,
			isValid: true
		};
	}

	enterEditMode() {
		this.isCancelled = false;
		this.latestValue = this.state.value;
		this.setState({
			isEditMode: true
		});
	}

	commitValue(e) {
		this.toggleInvalidMessage('none');

		if(this.isCancelled) {
			this.setState({
				isEditMode: false,
				value: this.latestValue
			});
		}
		else {
			if(this.props.validate(e.target.value)) {
				this.setState({
					isEditMode: false,
					value: e.target.value,
					isValid: true
				});
	
				if(e.target.value != this.latestValue) {
					this.props.onChange.call(null, e.target.value);
				}
			}
			else {
				this.setState({
					isEditMode: false,
					value: null,
					isValid: false
				});
				
				if(e.target.value != this.latestValue) {
					this.props.onChange.call(null, null);
				}
			}
		}
	}

	handleChange(e) {
		var state = {
			value: e.target.value
		}
		if(this.props.validate(e.target.value)) {
			state.isValid = true;
		}
		else {
			state.isValid = false;
		}
		this.setState(state);
			
	}

	handleKeydown(e) {
		if(e.keyCode === KEY_ESC || e.keyCode === KEY_ENTER) {
			if(e.keyCode === KEY_ESC) {
				this.isCancelled = true;
			}

			var dom = ReactDOM.findDOMNode(this.refs.nameInput)
			if(!!dom) {
				dom.blur();
			}
		}
	}
	
	toggleInvalidMessage(displayAttr) {
		if(!this.state.isValid) {
			var dom = ReactDOM.findDOMNode(this.refs.popover);
			dom.style.display = displayAttr;
		}
	}

	render() {

		var relative = {'position': 'relative'};
		if(!this.state.isValid) {
			var invdiv = (<div ref="popover" className="tooltip fade top in" style={{'display': 'none', 'top': '-35px'}}>
				<div className="tooltip-arrow"></div>
				<div className="tooltip-inner">{this.props.invalidMessage}</div>
			</div>);
		}
		else {
			var invdiv = null;
		}

		if(this.state.isEditMode) {
			return (
				<div style={relative}>
				<input type="text"
							 ref="nameInput"
							 value={this.state.value || ''}
							 className={this.state.isValid ? '' : 'invalid'}
							 onChange={this.handleChange.bind(this)}
							 onBlur={this.commitValue.bind(this)}
							 onFocus={this.toggleInvalidMessage.bind(this, 'block')}
							 onKeyDown={this.handleKeydown.bind(this)}></input>
							 {invdiv}
				</div>)
		}
		else {
			return (<div style={relative}>
				<a onClick={this.enterEditMode.bind(this)} 
					onMouseEnter={this.toggleInvalidMessage.bind(this, 'block')}
					onMouseLeave={this.toggleInvalidMessage.bind(this, 'none')}
					className={this.state.isValid ? '' : 'invalid'}>
					{this.state.value}</a>
				{invdiv}
			</div>);
		}
	}

	componentDidUpdate() {
		var dom = ReactDOM.findDOMNode(this.refs.nameInput)
		if(!!dom) {
			dom.focus();
		}
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			value: nextProps.model
		});
	}
}

export default InstantEditValidateBox;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/ui/InstantEditValidateBox.jsx